export class EngineError extends Error {
  code: string
  messageWithoutCode: string

  constructor(code: string, message: string) {
    super(message)
    this.messageWithoutCode = message
    this.message = `${code}: ${message}`
    this.code = code
  }
}
